import initialState from 'src/state'
import * as types from 'src/actions/types'

export default (state = initialState.windowHeight, action) =>
  action.type === types.SET_WINDOW_HEIGHT ? Number(action.payload) : state
